import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import styled from 'styled-components';
//Util
import server from 'server/serverController2';
//Component
import LottieLoader from 'components/containers/common/LottieLoader';
import CenterModal from 'components/presenters/modal/CenterModal';
//LottieFile And ImageFile
import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'

export default function CampaignJoinLayout({campaignNo}) {
    const userInfo = useSelector((state) => {
        return state.userInfo;
    })

    const history = useHistory();

    const [campaignInfo, setCampaignInfo] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    //LottieState
    const [lottieOptions, setLottieOptions] = useState(null);
    //CenterModalState
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState(null);
    const [onCenterModalComplete, setOnCenterModalCompalte] = useState(null);
    const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);
    const [initCenterModal, setInitCenterModal] = useState(false);


    const requestCampaignJoin = async () => {
      try
      {
        const body = {};
        const response = await server.postRequestData(`campaigns/${campaignNo}/members`, body);

        if(response?.success !== 1)
        {
            const errData = response.error.res_data;
            throw errData;
        }
        history.goBack();
      }
      catch(err)
      {
        console.log('error');
        console.log(err);
        if(err?.detail_code === 'LOGIN_REQUEST')
        {
          setCenterModalDataList({description:`로그인이 필요합니다.`});
          setOnCenterModalCompalte(()=>()=>{
            history.replace(`/social?redirect_path=/campaign/${campaignNo}`);
            setInitCenterModal(true);
          }); 
        }
        else if(err?.detail_code === 'CAMPAIGN_ALREADY_STARTED')
        {
          setCenterModalDataList({description:`이미 캠패인이 시작되었어요.`});
        }
        else if(err?.detail_code === 'BLOCKED_USER')
        {
          setCenterModalDataList({description:`해당 유저는 참여가 불가능 해요.`});
        }
        else if(err?.detail_code === 'CAMPAIGN_DOES_NOT_EXIST')
        {
          setCenterModalDataList({description:`해당 캠페인을 찾을 수 없어요.`});
        }
        else if(err?.detail_code === 'ALREADY_JOINED_CAMPAIGN')
        {
          setCenterModalDataList({description:`해당 캠페인은 이미 참여중 이에요.`});
        }
        else if(err?.detail_code === 'EXCEEDED_MAX_CAPACITY')
        {
          setCenterModalDataList({type: 'callback', description: `참여 정원을 초과하였어요.`})
        }

        setOnCenterModalCompalte(()=>()=>{
          history.goBack();
          setInitCenterModal(true);
        });
        setCenterModalVisible(true);
        setIsEnd(true);
      }
    }

    useEffect(() => {
      if(campaignNo)
      {
        (async () => {
            const response = await server.getRequestData(`campaigns/${campaignNo}`);
            if(response?.success !== 1)
            {
                return;
            }
            const campaignData = response?.data;
            setCampaignInfo(campaignData);
        })()
      }
    }, [])

    useEffect(() => {
        if(campaignNo && campaignInfo)
        {
            if(isLoading || isEnd) return;
            setIsLoading(true);
            setLottieOptions({
                loop: true,
                autoplay: true,
                renderer: 'svg',
                animationData: loadingAnimation
            })
            if(!campaignInfo?.waiting_list)
            {
              requestCampaignJoin();
            }
            else
            {
                history.replace(`/campaign/${campaignNo}/info`)
            }
        }
        else
        {
            setLottieOptions(null);
        }
    }, [campaignInfo])

    useEffect(() => {
        if(initCenterModal)
        {
            setCenterModalVisible(false);
            setCenterModalDataList(null);
            setOnCenterModalCompalte(null);
            setOnCenterModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal])

    return (
        <>
            {isLoading ? (
                <CampaignJoinSection>
                    <LottieAnimationWrapper>
                        <LottieLoader lottieOptions={lottieOptions} style={{width: 'calc(100vw * (45 / 375))'}}/>
                    </LottieAnimationWrapper>
                </CampaignJoinSection>
            ) : null}
            <CenterModal 
                modalVisible={centerModalVisible} 
                dataList={centerModalDataList} 
                onComplete={onCenterModalComplete} 
                onCancel={onCenterModalCancel}
            />
        </>
    )
}

const CampaignJoinSection = styled.div`
    height: 100vh;
    width: 100%;
    overflow: hidden;
`;

const LottieAnimationWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;